import React, {useState} from 'react';
import {IconButton, Stack, TextField, Typography, Button} from "@mui/material";
import {login} from "../firebase/auth";
import LoginIcon from '@mui/icons-material/Login';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoginShell from "./LoginShell";
import {LOGIN_COLORS} from "./LoginShell";
import {consumeReturnUrl} from "./loginReturnUrl";

export const demoUsers = [
    {
        name: 'Monica Reyes',
        email: 'monica.reyes@x-files.com',
        password: '0412341230',
        position: 'Policymaker',
        headshot: '/assets/monica.jpg',
        isAvailable: true,
    },
    {
        name: 'Alex Krycek',
        email: 'alex.krycek@x-files.com',
        password: '0412341230',
        position: 'Briefer',
        headshot: '/assets/alex.jpg',
        isAvailable: true,
    },
    {
        name: 'Alvin Kersh',
        email: 'alvin.kersh@x-files.com',
        password: '0412341230',
        position: 'Collection Manager',
        headshot: '/assets/alvin.jpg',
        isAvailable: true,
    },
    {
        name: 'John Doggett',
        email: 'john.doggett@x-files.com',
        password: '0412341230',
        position: 'Collector',
        headshot: '/assets/john.jpg',
        isAvailable: true,
    },
    {
        name: 'Walter Skinner',
        email: 'walter.skinner@x-files.com',
        password: '0412341230',
        position: 'Reviewer',
        headshot: '/assets/walter.jpg',
        isAvailable: true,
    },
    {
        name: 'Dana Scully',
        email: 'dana.scully@x-files.com',
        password: '0412341230',
        position: 'Analyst',
        headshot: '/assets/dana.jpg',
        isAvailable: true,
    },
    {
        name: 'Fox Mulder',
        email: 'fox.mulder@x-files.com',
        password: '0412341230',
        position: 'Analyst',
        headshot: '/assets/fox.jpg',
        isAvailable: true,
    },
    {
        name: 'Marita Covarrubias',
        email: 'marita.covarrubias@x-files.com',
        password: '0412341230',
        position: 'Disclosure Officer',
        headshot: '/assets/marita.jpg',
        isAvailable: true,
    },
    {
        name: 'Carl Gerhard Busch',
        email: 'carl.gerhard.busch@x-files.com',
        password: '0412341230',
        position: 'Manager',
        headshot: '/assets/carl.jpg',
        isAvailable: true,
    },
    {
        name: 'Dana Scott',
        email: 'dana.scott@ic.example.mil',
        password: '0412341230',
        position: 'Senior Regional Analyst',
        headshot: '/assets/avatars/1.jpg',
        isAvailable: true,
    },
    {
        name: 'Alvin Robertson',
        email: 'alvin.robertson@ic.example.mil',
        password: '0412341230',
        position: 'Defense Intelligence Analyst',
        headshot: '/assets/avatars/3.jpg',
        isAvailable: true,
    },
    {
        name: 'Monica Blake',
        email: 'monica.blake@ic.example.mil',
        password: '0412341230',
        position: 'All-Source Analyst',
        headshot: '/assets/avatars/2.jpg',
        isAvailable: true,
    },
    {
        name: 'John Keller',
        email: 'john.keller@ic.example.mil',
        password: '0412341230',
        position: 'Regional Analyst',
        headshot: '/assets/avatars/4.jpg',
        isAvailable: true,
    },
    {
        name: 'Walter Lin',
        email: 'walter.lin@ic.example.mil',
        password: '0412341230',
        position: 'Senior Country Desk Officer',
        headshot: '/assets/avatars/6.jpg',
        isAvailable: true,
    },
    {
        name: 'Fox Morgan',
        email: 'fox.morgan@ic.example.mil',
        password: '0412341230',
        position: 'Analytic Methodologist',
        headshot: '/assets/avatars/7.jpg',
        isAvailable: true,
    },
]

const DemoUsersLoginPage = ({alert, onBack}) => {
    // initialize per-user password inputs from the users array
    const [passwords, setPasswords] = useState(() => demoUsers.map(() => ''))
    // track per-user error messages
    const [errors, setErrors] = useState(() => demoUsers.map(() => ''))

    return (
        <LoginShell alert={alert}>
            <Stack spacing={1.5}>
                {onBack && (
                    <Button
                        onClick={onBack}
                        startIcon={<ArrowBackIcon />}
                        sx={{
                            color: LOGIN_COLORS.slate500,
                            textTransform: 'none',
                            fontSize: 13,
                            px: 0,
                            justifyContent: 'flex-start',
                            minWidth: 'auto',
                            mb: 1,
                            '&:hover': {
                                bgcolor: 'transparent',
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Back to Login
                    </Button>
                )}

                <Stack
                    spacing={1}
                    sx={{
                        maxHeight: {xs: 'calc(100vh - 280px)', md: '450px'},
                        overflowY: 'auto',
                        pr: 0.5,
                    }}
                >
                    {demoUsers
                        .filter(user => user.position !== 'Admin')
                        .map((user, index) => {
                            // Get the original index for password/error state management
                            const originalIndex = demoUsers.indexOf(user);
                            return (
                            <Stack
                            key={originalIndex}
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                            p={1.5}
                            border="1px solid"
                            borderColor={LOGIN_COLORS.slate200}
                            borderRadius={2}
                            sx={{
                                bgcolor: 'white',
                                cursor: 'pointer',
                                transition: 'all 0.15s',
                                '&:hover': {
                                    borderColor: LOGIN_COLORS.brand,
                                    boxShadow: '0 2px 8px rgba(37, 99, 235, 0.1)',
                                },
                            }}
                        >
                            <img
                                src={user.headshot}
                                alt={user.name}
                                style={{
                                    borderRadius: '50%',
                                    width: 40,
                                    height: 40,
                                    objectFit: 'cover',
                                }}
                            />
                            <Stack flex={1} minWidth={0}>
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 600,
                                        color: LOGIN_COLORS.slate900,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {user.name}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: 12,
                                        color: LOGIN_COLORS.slate500,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {user.position}
                                </Typography>
                            </Stack>
                            <TextField
                                type="password"
                                placeholder="Password"
                                size="small"
                                value={passwords[originalIndex]}
                                onChange={(e) => {
                                    const next = [...passwords]
                                    next[originalIndex] = e.target.value
                                    setPasswords(next)
                                    if (errors[originalIndex]) {
                                        const nextErrors = [...errors]
                                        nextErrors[originalIndex] = ''
                                        setErrors(nextErrors)
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        handleLogin(user.email, passwords[originalIndex], originalIndex)
                                    }
                                }}
                                disabled={!user.isAvailable}
                                error={!!errors[originalIndex]}
                                sx={{
                                    width: 140,
                                    '& .MuiOutlinedInput-root': {
                                        fontSize: 13,
                                        '& fieldset': {
                                            borderColor: LOGIN_COLORS.slate200,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: LOGIN_COLORS.slate200,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: LOGIN_COLORS.brand,
                                        },
                                    },
                                }}
                            />
                            <IconButton
                                size="small"
                                disabled={!user.isAvailable}
                                onClick={(e) => {
                                    if (!user.isAvailable) return
                                    e.stopPropagation()
                                    handleLogin(user.email, passwords[originalIndex], originalIndex)
                                }}
                                sx={{
                                    color: LOGIN_COLORS.brand,
                                    '&:hover': {
                                        bgcolor: 'rgba(37, 99, 235, 0.1)',
                                    },
                                }}
                            >
                                <LoginIcon fontSize="small" />
                            </IconButton>
                        </Stack>
                        );
                    })}
                </Stack>
                
                {errors.some(e => e) && (
                    <Typography
                        sx={{
                            fontSize: 12,
                            color: '#dc2626',
                            mt: 1,
                        }}
                    >
                        {errors.find(e => e)}
                    </Typography>
                )}
            </Stack>
        </LoginShell>
    );

    async function handleLogin(email, password, index) {
        // Clear any existing error for this user
        const nextErrors = [...errors]
        nextErrors[index] = ''
        setErrors(nextErrors)

        try {
            await login({email, password});
            const returnUrl = consumeReturnUrl();
            if (returnUrl) {
                window.location.replace(returnUrl);
            }
        } catch (error) {
            // Map auth error codes to user-friendly messages
            let errorMessage = 'Login failed. Please try again.'
            if (error.code === 'auth/missing-password') {
                errorMessage = 'Password is required.'
            } else if (error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
                errorMessage = 'Incorrect password.'
            } else if (error.code === 'auth/user-not-found') {
                errorMessage = 'User not found.'
            } else if (error.code === 'auth/too-many-requests') {
                errorMessage = 'Too many attempts. Try again later.'
            } else if (error.code === 'auth/invalid-email') {
                errorMessage = 'Invalid email address.'
            }

            const updatedErrors = [...errors]
            updatedErrors[index] = errorMessage
            setErrors(updatedErrors)
        }
    }
};

export default DemoUsersLoginPage;
